import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { Grid, Typography } from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  headerLabel: {
    fontWeight: 800,
    color: theme.color.text.textHeader,
    // [theme.breakpoints.down('xs')]: {
    //   marginBottom: theme.spacing(1),
    // },
  },
  footerLabel: {
    fontWeight: 800,
    color: theme.color.text.textHeader,
  },
  bodyLabel: {
    color: theme.color.text.textPrimary,
    fontWeight: 'normal',
  },
  headerValue: {
    color: theme.color.text.textHeader,
    fontWeight: 800,
    textAlign: 'right',
  },
  bodyValue: {
    color: theme.color.text.textPrimary,
  },
  footerValue: {
    fontWeight: 800,
  },
  value: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  eachRow: {
    marginBottom: theme.spacing(1),
    '&:nth-last-child(2)': {
      marginBottom: theme.spacing(3),
    },
  },
}));

type Variant = 'header' | 'footer' | 'body';

const FeeRow = ({
  variant = 'body',
  label,
  value,
  currencyDenomination = true,
}: {
  variant?: Variant;
  label: string;
  value: string;
  currencyDenomination?: boolean;
}) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    (<Grid md={12} container direction="row" justify="flex-start" className={classes.eachRow}>
      <Grid xs={12} sm={6}>
        <Typography
          display="block"
          variant={variant === 'body' ? 'body1' : 'h4'}
          align="left"
          // @ts-ignore
          className={classes[`${variant}Label`]}
        >
          {label}
        </Typography>
      </Grid>
      <Grid
        container
        xs={12}
        sm={2}
        direction="row"
        justify={isMobile ? 'flex-start' : 'flex-end'}
      >
        <Typography
          display="block"
          variant={variant === 'footer' ? 'h4' : 'body1'}
          align="left"
          // @ts-ignore
          className={classes[`${variant}Value`]}
        >
          {currencyDenomination ? `S$${value}` : value}
        </Typography>
      </Grid>
    </Grid>)
  );
};

export default FeeRow;
